import React, { useEffect, useState } from 'react';

import { CheckIcon } from '@heroicons/react/20/solid';

import config from '../../config';

import { loadStripe } from '@stripe/stripe-js';
import { format } from 'date-fns';


import { Badge } from '../../catalyst/badge';
import { Button } from '../../catalyst/button';
import { Dialog, DialogBody, DialogDescription, DialogTitle } from '../../catalyst/dialog';
import { Heading } from '../../catalyst/heading';
import LoadingMain from '../../components/LoadingMain';
import Spinning from '../../components/spinning';

const stripePromise = loadStripe(config.stripePublicKey);



const tiers = [
  {
    name: 'One month (30 days)',
    id: 'tier-30days',
    href: '#',
    price: '$1.99',
    description: 'The essentials to transfer the playlists and try sync.',
    features: ['Transfer unlimited tracks/albums', 'Search and add missing items', 'No monthly subsciption', '48-hour support response time'],
    featured: false,
    cta: 'Choose plan',
    priceSuffix: ' once, no subscription'
  },
  {
    name: 'Monthly',
    id: 'tier-monthly',
    href: '#',
    price: '$1.79',
    description: 'A plan that scales for your hobby',
    features: ['Transfer unlimited tracks/albums', 'Search and add missing items', '48-hour support response time'
    ],
    featured: false,
    cta: 'Choose plan',
    priceSuffix: ' /month'
  },
  {
    name: 'Lifetime',
    id: 'tier-lifetime',
    href: '#',
    price: '$29.99',
    description: 'Pay once and control your music forever',
    features: [ 'Access to premium feature for lifetime', 'Transfer unlimited tracks/albums', 'Search and add missing items', '48-hour support response time'
    ],
    featured: false,
    cta: 'Choose plan',
    priceSuffix: ' once, free forever'
  },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}



export default function PremiumOptions() {



  const [openMonth, setMonthOpen] = React.useState(false);
  const handleMonthOpen = () => setMonthOpen(true);
  const handleMonthClose = () => setMonthOpen(false);

  const [openLifetime, setLifetimeOpen] = React.useState(false);
  const handleLifetimeOpen = () => setLifetimeOpen(true);
  const handleLifetimeClose = () => setLifetimeOpen(false);

  const [openMonthly, setMonthlyOpen] = React.useState(false);
  const handleMonthlyOpen = () => setMonthlyOpen(true);
  const handleMonthlyClose = () => setMonthlyOpen(false);

  const [loading, setLoading] = useState(true); // State to track loading state
  const [tier, setTier] = useState(''); // Tier can be 'Free' or 'Premium'
  const [onTrial, setOnTrial] = useState(false);
  const [premiumExpiresOn, setPremiumExpiresOn] = useState('')
  const [paymentMode, setPaymentMode] = useState('')
  const [trialExpiresOn, setTrialExpiresOn] = useState('')

  const params = new URLSearchParams(window.location.search);
  const [redirectMessage, setRedirectMessage] = useState(params.get('message'))


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true); // Set loading state to true
        const response = await fetch(config.apiUrl + "/user", {
          headers: {
            'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken,
          }
        });

        const status = await response.status;
        if (status === 200) {
          let data = await response.json()
          setTier(data.premium ? 'Premium' : 'Free')
          setOnTrial(data.onTrialPeriod)
          setTrialExpiresOn(data.trialEndTime)
          if (data.premium) {
            setPremiumExpiresOn(data.premiumExpiresOn)
            setPaymentMode(data.paymentMode)
          }
        } else {
          throw new Error('Failed to get profile');
        }

      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false)
      } finally {
        setLoading(false); // Set loading state to false after fetch completes

      }
    };

    fetchData();
  }, []);



  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };


  function  CheckoutForm({stripePriceType}) {
    useEffect(() => {
      console.log("Fetching data")
      const fetchData = async () => {
      // Create a Checkout Session
      return fetch(config.apiUrl + "/stripe/createCheckoutSession?stripePriceType=" + stripePriceType, {
        method: "GET",
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken,
          'Content-Type': 'application/json'
        },
      })
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          window.location.href = data.stripeSession.url;
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }

        fetchData();
      }, []);


    return (
      <div id="checkout">
        <DialogDescription>
          <Spinning/>Redirecting to Stripe payment page...
        </DialogDescription>
      </div>
    )
  }


  function handlePremiumOpen(selected) {
    if(selected === "tier-30days") {
      handleMonthOpen()
    } else if(selected === "tier-monthly") {
      handleMonthlyOpen()
    } else if (selected === "tier-lifetime") {
      handleLifetimeOpen()
    }
    
  }

  function premiumSubscriptionNotice(endDate) {
    const formattedDate = format(new Date(endDate), 'MMMM do, yyyy, h:mm a');

    if(onTrial) {
      return (
        <div className="flex items-center gap-x-6 bg-gray-900 dark:bg-zinc-800 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
          <p className="text-sm/6 text-white dark:text-zinc-100">
            Your trial will end on {format(new Date(trialExpiresOn), 'MMMM do, yyyy, h:mm a')}. 
            You can upgrade to a paid plan at any time and help us to build a better product for you.

          </p>
          <p className="text-sm/6 text-white dark:text-zinc-100">
          </p>
        </div>
      )
    }
    return (
      <div className="flex items-center gap-x-6 bg-gray-900 dark:bg-zinc-800 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
      <p className="text-sm/6 text-white dark:text-zinc-100">
        
          {paymentMode === "SUBSCRIPTION" ? "Premium Subscription Active. Your subscription will renew on " : "Your premium is active until "} {formattedDate}.
      </p>
    </div>
    )
  }

  function featuresView(disablePurchase) {
    return (<>
        <div className="bg-white dark:bg-zinc-950 pt-10 pb-10">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <p className="mt-2 text-5xl font-semibold tracking-tight text-balance text-gray-900 dark:text-white sm:text-6xl">
            Pricing that grows with you
          </p>
        </div>
        <p className="mx-auto mt-6 max-w-2xl text-center text-lg font-medium text-pretty text-gray-600 sm:text-xl/8">
          Choose an affordable plan that’s packed with the best options for you
        </p>
        <div className="isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {tiers.map((tier) => (
            <div
              key={tier.id}
              className={classNames(
                tier.featured ? 'bg-gray-900 dark:bg-zinc-800 ring-gray-900 dark:ring-zinc-700' : 'ring-gray-200 dark:ring-zinc-700',
                'rounded-3xl p-8 ring-1 xl:p-10 bg-white dark:bg-zinc-900',
              )}
            >
              <h3
                id={tier.id}
                className={classNames(tier.featured ? 'text-white dark:text-zinc-100' : 'text-gray-900 dark:text-white', 'text-lg/8 font-semibold')}
              >
                {tier.name}
              </h3>
              <p className={classNames(tier.featured ? 'text-gray-300 dark:text-zinc-300' : 'text-gray-600 dark:text-gray-400', 'mt-4 text-sm/6')}>
                {tier.description}
              </p>
              <p className="mt-6 flex items-baseline gap-x-1">
                <span
                  className={classNames(
                    tier.featured ? 'text-white dark:text-zinc-100' : 'text-gray-900 dark:text-white',
                    'text-4xl font-semibold tracking-tight',
                  )}
                >
                  {tier.price}
                </span>
                <span
                    className={classNames(tier.featured ? 'text-gray-300 dark:text-zinc-300' : 'text-gray-600 dark:text-gray-400', 'text-sm/6 font-semibold')}
                  >
                    {tier.priceSuffix}
                  </span>
              </p>
              <Button
                onClick={() => handlePremiumOpen(tier.id)}
                href="#"
                aria-describedby={tier.id}
                className='w-full my-5 bg-zinc-900 dark:bg-zinc-800 text-white dark:text-zinc-100 hover:bg-zinc-800 dark:hover:bg-zinc-700'
                disabled={disablePurchase}
              >
                {tier.cta}
              </Button>
              <ul
                role="list"
                className={classNames(
                  tier.featured ? 'text-gray-300 dark:text-zinc-300' : 'text-gray-600 dark:text-zinc-200',
                  'mt-8 space-y-3 text-sm/6 xl:mt-10',
                )}
              >
                {tier.features.map((feature) => (
                  <li key={feature} className="flex gap-x-3">
                    <CheckIcon
                      aria-hidden="true"
                      className={classNames(tier.featured ? 'text-white dark:text-zinc-100' : 'text-zinc-900 dark:text-white', 'h-6 w-5 flex-none')}
                    />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>


        <Dialog
          open={openMonth}
          onClose={handleMonthClose}
          className="dark:bg-zinc-900"
        >
            <DialogTitle className="dark:text-white">Buy one Month/30 days plan</DialogTitle>

          <DialogBody className="dark:bg-zinc-900">
            {openMonth && <CheckoutForm stripePriceType="MONTH"/>}
          </DialogBody>
        </Dialog>

        <Dialog
          open={openLifetime}
          onClose={handleLifetimeClose}
          className="dark:bg-zinc-900"
        >
            <DialogTitle className="dark:text-white">Buy Lifetime plan</DialogTitle>

          <DialogBody className="dark:bg-zinc-900">
            {openLifetime && <CheckoutForm stripePriceType="LIFETIME"/>}
          </DialogBody>
        </Dialog>

        <Dialog
          open={openMonthly}
          onClose={handleMonthlyClose}
          className="dark:bg-zinc-900"
        >
            <DialogTitle className="dark:text-white">Buy monthly subscription</DialogTitle>

          <DialogBody className="dark:bg-zinc-900">
            {openMonthly && <CheckoutForm stripePriceType="MONTHLY"/>}
          </DialogBody>
        </Dialog>
    
    </>
    )
  }

  return (
    <>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div className="max-sm:w-full sm:flex-1">
          <Heading>Premium options</Heading>
          <div className="mt-5">
            {redirectMessage === "PAYMENT_NOT_COMPLETE" ? <Badge color="rose">Payment not complete. Please try again or contact us.</Badge> : <></>}
            {redirectMessage === "PAYMENT_COMPLETE" ? <Badge color="lime" >Thank you. You are now a premium user.</Badge> : <></>}




            {loading ? <>
              <LoadingMain />
              {featuresView(true || redirectMessage === "PAYMENT_COMPLETE")}
            </> :

              tier === 'Free' ?
                <>
                  {featuresView(false || redirectMessage === "PAYMENT_COMPLETE")}
                </>
                :
                <>
                  {premiumSubscriptionNotice(premiumExpiresOn)}
                  {featuresView(!onTrial || redirectMessage === "PAYMENT_COMPLETE")}
                </>
            }


          </div>
        </div>

      </div>
    </>
  )
}